// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../ASSETS/BACKGROUND/homeHeroBg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pageHero_hero__EdvVE {
  position: relative;
  background: var(--color-ink) url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center / cover no-repeat;
  color: var(--color-text-on-dark);
  font-family: var(--font-sans);
  overflow: clip;
  isolation: isolate;
}
.pageHero_hero__EdvVE::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: -1;
  background: linear-gradient(90deg, rgba(18, 21, 26, 0.96) 0%, rgba(18, 21, 26, 0.86) 50%, rgba(18, 21, 26, 0.6) 100%);
}
.pageHero_inner__kjB0u {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
}
.pageHero_copy__gewdp {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-5);
  padding: 2.5rem var(--gutter) clamp(3rem, 7vw, 4.5rem);
  box-sizing: border-box;
}
.pageHero_eyebrow__K6MxX {
  margin: 0;
  font-size: var(--text-eyebrow);
  letter-spacing: var(--tracking-eyebrow);
  text-transform: uppercase;
  font-weight: 700;
  color: var(--color-text-muted-on-dark);
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.pageHero_eyebrow__K6MxX::before {
  content: "";
  width: 2rem;
  height: 2px;
  background: var(--color-accent);
}
.pageHero_title__ygVw7 {
  margin: 0;
  font-size: var(--text-h1);
  line-height: var(--leading-tight);
  font-weight: 500;
  letter-spacing: var(--tracking-display);
  text-wrap: balance;
}
.pageHero_title__ygVw7 em {
  font-style: normal;
  color: var(--color-accent);
}
.pageHero_lead__JF-hh {
  margin: 0;
  max-width: 36rem;
  font-size: var(--text-body-lg);
  line-height: var(--leading-body);
  color: var(--color-text-muted-on-dark);
}
.pageHero_actions__V5EXt {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
  margin-top: var(--space-2);
}
.pageHero_note__hChEL {
  max-width: 32rem;
  padding-top: var(--space-5);
  border-top: 1px solid var(--color-border-on-dark);
  font-size: var(--text-caption);
  line-height: 1.55;
  color: var(--color-text-muted-on-dark);
}

.pageHero_visual__VZdRh {
  position: relative;
  order: -1;
  height: clamp(14rem, 40svh, 24rem);
  margin-top: 5rem;
}
.pageHero_arc__fBIR9 {
  position: absolute;
  inset: 0 0 -10px;
  background: var(--color-accent);
  clip-path: ellipse(75% 100% at 50% 0%);
}
.pageHero_photo__qprrN {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 30%;
  clip-path: ellipse(75% 100% at 50% 0%);
  animation: pageHero_revealBanner__47\\+2- 1.1s var(--ease-out) 0.05s backwards;
}
@keyframes pageHero_revealBanner__47\\+2- {
  from {
    clip-path: ellipse(75% 0% at 50% 0%);
  }
}
@keyframes pageHero_revealSide__pxJe9 {
  from {
    clip-path: ellipse(0% 80% at 100% 50%);
  }
}
@media (prefers-reduced-motion: reduce) {
  .pageHero_photo__qprrN {
    animation: none;
  }
}

@media (min-width: 992px) {
  .pageHero_hero__EdvVE {
    min-height: min(88svh, 50rem);
    display: flex;
  }
  .pageHero_inner__kjB0u {
    width: 100%;
    grid-template-columns:
      [full-start] minmax(var(--gutter), 1fr)
      [content-start] minmax(0, calc(var(--container) / 2))
      [middle] minmax(0, calc(var(--container) / 2))
      [content-end] minmax(var(--gutter), 1fr)
      [full-end];
  }
  .pageHero_copy__gewdp {
    grid-column: content-start / middle;
    grid-row: 1;
    justify-content: center;
    padding: 8rem var(--space-6) 5rem 0;
  }
  .pageHero_visual__VZdRh {
    grid-column: middle / full-end;
    grid-row: 1;
    order: 0;
    height: auto;
    margin-top: 0;
  }
  .pageHero_arc__fBIR9 {
    inset: 0;
    left: -14px;
    clip-path: ellipse(100% 80% at 100% 50%);
  }
  .pageHero_photo__qprrN {
    clip-path: ellipse(100% 80% at 100% 50%);
    animation-name: pageHero_revealSide__pxJe9;
  }
}
`, "",{"version":3,"sources":["webpack://./src/COMPONENTS/PAGE_HERO/pageHero.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,6FAAmG;EACnG,gCAAgC;EAChC,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,qHAAqH;AACvH;AACA;EACE,aAAa;EACb,qCAAqC;AACvC;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,sDAAsD;EACtD,sBAAsB;AACxB;AACA;EACE,SAAS;EACT,8BAA8B;EAC9B,uCAAuC;EACvC,yBAAyB;EACzB,gBAAgB;EAChB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,+BAA+B;AACjC;AACA;EACE,SAAS;EACT,yBAAyB;EACzB,iCAAiC;EACjC,gBAAgB;EAChB,uCAAuC;EACvC,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,8BAA8B;EAC9B,gCAAgC;EAChC,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,iDAAiD;EACjD,8BAA8B;EAC9B,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,kCAAkC;EAClC,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,sCAAsC;AACxC;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,sCAAsC;EACtC,6EAA4D;AAC9D;AACA;EACE;IACE,oCAAoC;EACtC;AACF;AACA;EACE;IACE,sCAAsC;EACxC;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,6BAA6B;IAC7B,aAAa;EACf;EACA;IACE,WAAW;IACX;;;;;gBAKY;EACd;EACA;IACE,mCAAmC;IACnC,WAAW;IACX,uBAAuB;IACvB,mCAAmC;EACrC;EACA;IACE,8BAA8B;IAC9B,WAAW;IACX,QAAQ;IACR,YAAY;IACZ,aAAa;EACf;EACA;IACE,QAAQ;IACR,WAAW;IACX,wCAAwC;EAC1C;EACA;IACE,wCAAwC;IACxC,0CAA0B;EAC5B;AACF","sourcesContent":[".hero {\n  position: relative;\n  background: var(--color-ink) url(\"../../ASSETS/BACKGROUND/homeHeroBg.jpg\") center / cover no-repeat;\n  color: var(--color-text-on-dark);\n  font-family: var(--font-sans);\n  overflow: clip;\n  isolation: isolate;\n}\n.hero::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  z-index: -1;\n  background: linear-gradient(90deg, rgba(18, 21, 26, 0.96) 0%, rgba(18, 21, 26, 0.86) 50%, rgba(18, 21, 26, 0.6) 100%);\n}\n.inner {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n}\n.copy {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: var(--space-5);\n  padding: 2.5rem var(--gutter) clamp(3rem, 7vw, 4.5rem);\n  box-sizing: border-box;\n}\n.eyebrow {\n  margin: 0;\n  font-size: var(--text-eyebrow);\n  letter-spacing: var(--tracking-eyebrow);\n  text-transform: uppercase;\n  font-weight: 700;\n  color: var(--color-text-muted-on-dark);\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n.eyebrow::before {\n  content: \"\";\n  width: 2rem;\n  height: 2px;\n  background: var(--color-accent);\n}\n.title {\n  margin: 0;\n  font-size: var(--text-h1);\n  line-height: var(--leading-tight);\n  font-weight: 500;\n  letter-spacing: var(--tracking-display);\n  text-wrap: balance;\n}\n.title em {\n  font-style: normal;\n  color: var(--color-accent);\n}\n.lead {\n  margin: 0;\n  max-width: 36rem;\n  font-size: var(--text-body-lg);\n  line-height: var(--leading-body);\n  color: var(--color-text-muted-on-dark);\n}\n.actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-3);\n  margin-top: var(--space-2);\n}\n.note {\n  max-width: 32rem;\n  padding-top: var(--space-5);\n  border-top: 1px solid var(--color-border-on-dark);\n  font-size: var(--text-caption);\n  line-height: 1.55;\n  color: var(--color-text-muted-on-dark);\n}\n\n.visual {\n  position: relative;\n  order: -1;\n  height: clamp(14rem, 40svh, 24rem);\n  margin-top: 5rem;\n}\n.arc {\n  position: absolute;\n  inset: 0 0 -10px;\n  background: var(--color-accent);\n  clip-path: ellipse(75% 100% at 50% 0%);\n}\n.photo {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center 30%;\n  clip-path: ellipse(75% 100% at 50% 0%);\n  animation: revealBanner 1.1s var(--ease-out) 0.05s backwards;\n}\n@keyframes revealBanner {\n  from {\n    clip-path: ellipse(75% 0% at 50% 0%);\n  }\n}\n@keyframes revealSide {\n  from {\n    clip-path: ellipse(0% 80% at 100% 50%);\n  }\n}\n@media (prefers-reduced-motion: reduce) {\n  .photo {\n    animation: none;\n  }\n}\n\n@media (min-width: 992px) {\n  .hero {\n    min-height: min(88svh, 50rem);\n    display: flex;\n  }\n  .inner {\n    width: 100%;\n    grid-template-columns:\n      [full-start] minmax(var(--gutter), 1fr)\n      [content-start] minmax(0, calc(var(--container) / 2))\n      [middle] minmax(0, calc(var(--container) / 2))\n      [content-end] minmax(var(--gutter), 1fr)\n      [full-end];\n  }\n  .copy {\n    grid-column: content-start / middle;\n    grid-row: 1;\n    justify-content: center;\n    padding: 8rem var(--space-6) 5rem 0;\n  }\n  .visual {\n    grid-column: middle / full-end;\n    grid-row: 1;\n    order: 0;\n    height: auto;\n    margin-top: 0;\n  }\n  .arc {\n    inset: 0;\n    left: -14px;\n    clip-path: ellipse(100% 80% at 100% 50%);\n  }\n  .photo {\n    clip-path: ellipse(100% 80% at 100% 50%);\n    animation-name: revealSide;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hero": `pageHero_hero__EdvVE`,
	"inner": `pageHero_inner__kjB0u`,
	"copy": `pageHero_copy__gewdp`,
	"eyebrow": `pageHero_eyebrow__K6MxX`,
	"title": `pageHero_title__ygVw7`,
	"lead": `pageHero_lead__JF-hh`,
	"actions": `pageHero_actions__V5EXt`,
	"note": `pageHero_note__hChEL`,
	"visual": `pageHero_visual__VZdRh`,
	"arc": `pageHero_arc__fBIR9`,
	"photo": `pageHero_photo__qprrN`,
	"revealBanner": `pageHero_revealBanner__47+2-`,
	"revealSide": `pageHero_revealSide__pxJe9`
};
export default ___CSS_LOADER_EXPORT___;
